export enum BoardType {
	DASHBOARD = 'dashboard',
	STATUSBOARD = 'statusboard',
}
